import useProfile, { UserProfile, UserProfileUpdated } from 'hooks/useProfile';
import { createContext } from 'react';

export type UserContextProfile = {
    profile: UserProfile;
    updateUserProfile: (profile: UserProfileUpdated) => Promise<void>;
};

type ProfileProviderProps = { children: React.ReactNode };

export const ProfileContext = createContext<any>({
    profile: {
        profileImage: {
            base64: '',
            fileType: ''
        },
        name: '',
        username: '',
        email: '',
        phone: '',
        company: {
            code: '',
            id: '',
            name: ''
        },
        dni: '',
        permissions: []
    },
    updateUserProfile: async () => {}
});

export default function ProfileProvider({ children }: ProfileProviderProps) {
    const {
        profile,
        updateUserProfile,
        getUserProfile,
        updateUserPassword,
        profileIsReady,
        getListFilters,
        updateUserSmsConfig,
        updateUserEmailConfig,
        blocked
    } = useProfile();

    return (
        <ProfileContext.Provider
            value={{
                profile,
                updateUserProfile,
                getUserProfile,
                updateUserPassword,
                profileIsReady,
                getListFilters,
                updateUserSmsConfig,
                updateUserEmailConfig,
                blocked
            }}
        >
            {children}
        </ProfileContext.Provider>
    );
}
